import { render, staticRenderFns } from "./TheHistoricalSiteIcon.vue?vue&type=template&id=1e69f744&"
import script from "./TheHistoricalSiteIcon.vue?vue&type=script&lang=js&"
export * from "./TheHistoricalSiteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports